module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showModal),
      expression: "showModal"
    }],
    staticClass: "modal-box",
    on: {
      "click": _vm.close
    }
  }, [_c('div', {
    attrs: {
      "id": "mask"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-wrapper",
    attrs: {
      "id": "modal"
    }
  }, [_c('div', {
    staticClass: "modal-head"
  }, [_vm._v("消息")]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_vm._v("\n\t        您还没登录CNODE，是否前往认证登录?\n\t    ")]), _vm._v(" "), _c('div', {
    staticClass: "modal-foot"
  }, [_c('a', {
    staticClass: "btn btn-cancel",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.close
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-sure",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.toLogin
    }
  }, [_vm._v("确定")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3ffc8b7c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modal.vue
// module id = 46
// module chunks = 0